/* MOMMYSLOVE - regalo sorpresa automatico en el carrito.
   >= 100 EUR: gorra sorpresa. >= 150 EUR: camiseta sorpresa (en lugar de la gorra).
   Anade/quita el producto de regalo (precio 0, inventario real) segun el total del carrito.
   Antes de anadir un regalo comprueba su disponibilidad en tiempo real. */
(function () {
  var C = window.mmlGift;
  if (!C || !C.active || window.__mmlGiftBound) return;
  window.__mmlGiftBound = true;

  var CAP_MIN = 10000, TEE_MIN = 15000;
  var CAP_HANDLE = 'regalo-gorra-sorpresa', TEE_HANDLE = 'regalo-camiseta-sorpresa';
  var originalFetch = window.fetch.bind(window);
  var running = false, again = false, timer = null;

  function isGift(item) {
    return item.variant_id === C.cap.id || item.variant_id === C.tee.id;
  }

  function jsonHeaders() {
    return { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  }

  function refresh() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  /* Disponibilidad real (la de la pagina puede llevar unos segundos de retraso) */
  function available(handle, fallbackQty, needed) {
    if (!needed) return Promise.resolve(false);
    return originalFetch('/products/' + handle + '.js?_=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) { return !!(p && p.variants && p.variants[0] && p.variants[0].available); })
      .catch(function () { return fallbackQty > 0; });
  }

  function sync() {
    if (running) { again = true; return; }
    running = true;
    var changedAnything = false;

    originalFetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var paid = 0, hasPaid = false;
        cart.items.forEach(function (i) {
          if (!isGift(i)) { paid += i.final_line_price; hasPaid = true; }
        });

        var needTee = hasPaid && paid >= TEE_MIN;
        var needCap = hasPaid && paid >= CAP_MIN;

        return Promise.all([
          available(TEE_HANDLE, C.tee.qty, needTee),
          available(CAP_HANDLE, C.cap.qty, needCap)
        ]).then(function (av) {
          var want = null;
          if (needTee && av[0]) want = C.tee;
          else if (needCap && av[1]) want = C.cap;

          var remove = {}, needRemove = false, toAdd = null;
          [C.cap, C.tee].forEach(function (g) {
            var line = cart.items.filter(function (i) { return i.variant_id === g.id; })[0];
            var cur = line ? line.quantity : 0;
            var qty = (want && want.id === g.id) ? 1 : 0;
            if (cur === qty) return;
            if (qty === 0) { remove[g.id] = 0; needRemove = true; }
            else if (cur === 0) { toAdd = g; }
            else { remove[g.id] = 1; needRemove = true; }
          });

          var chain = Promise.resolve();
          if (needRemove) {
            chain = chain.then(function () {
              changedAnything = true;
              return originalFetch('/cart/update.js', {
                method: 'POST', credentials: 'same-origin', headers: jsonHeaders(),
                body: JSON.stringify({ updates: remove })
              });
            });
          }
          if (toAdd) {
            chain = chain.then(function () {
              changedAnything = true;
              return originalFetch('/cart/add.js', {
                method: 'POST', credentials: 'same-origin', headers: jsonHeaders(),
                body: JSON.stringify({ id: toAdd.id, quantity: 1 })
              });
            });
          }
          return chain;
        });
      })
      .catch(function () {})
      .then(function () {
        running = false;
        if (changedAnything) refresh();
        if (again) { again = false; schedule(250); }
      });
  }

  function schedule(ms) {
    clearTimeout(timer);
    timer = setTimeout(sync, ms || 300);
  }

  /* Detectar cambios de carrito hechos por el tema (anadir, cambiar cantidad, quitar) */
  window.fetch = function (input, init) {
    var url = '';
    try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
    var p = originalFetch(input, init);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { schedule(450); }, function () {});
    }
    return p;
  };

  document.addEventListener('product:added', function () { schedule(500); });
  document.documentElement.addEventListener('cart:refresh', function () { schedule(300); });
  window.addEventListener('pageshow', function () { schedule(300); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { schedule(300); });
  } else {
    schedule(300);
  }
})();
